import React, { Component } from 'react'
import PropTypes from "prop-types";
import BaseMessageLayout from './BaseMessageLayout'

class ConnectConsentMessage extends Component {
    static  propTypes ={
        messagedate: PropTypes.string,
        hours: PropTypes.number,
        minutes: PropTypes.number,
        openModalConnect: PropTypes.func,
    }

    render() {
        const { messagedate, hours, minutes, resource, type, openModalConnect} = this.props
        return (
           <BaseMessageLayout
                messagedate={messagedate}
                hours={hours}
                minutes={minutes}
                resource={resource}
                type={type}
                originname={this.props.originname}
                displayoriginname={this.props.displayoriginname}
                >
                  <p class="my-0 mb-2"><strong>Let's swap contact info!</strong></p>
                  <button class="btn btn-primary" type="button" onClick={() => openModalConnect(true) }>Agree to Share</button>
            </BaseMessageLayout>
        )
    }
}

export default ConnectConsentMessage
